import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, PLATFORM_ID, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

interface SidebarMenuItem {
  label: string;
  route: string;
  icon: string;
}

const SIDEBAR_MENU_ITEMS: SidebarMenuItem[] = [
  { label: 'Gestionar productos', route: 'productos/detalle', icon: 'assets/icons/package.svg' },
  { label: 'Gestión de colores', route: 'colores', icon: 'assets/icons/palette.svg' },
  { label: 'Gestionar categorías', route: 'categorias', icon: 'assets/icons/tags.svg' },
  { label: 'Gestionar llaveros', route: 'llaveros', icon: 'assets/icons/keychain-logo.svg' },
  { label: 'Cajas de envío', route: 'cajas-envio', icon: 'assets/icons/box.svg' },
  { label: 'Historial de pedidos', route: 'pedidos', icon: 'assets/icons/receipt.svg' },
  { label: 'Gestionar Página Principal', route: 'pagina-principal', icon: 'assets/icons/layout-dashboard.svg' },
];

/** Recuerda si el menú quedó contraído, para no reabrirlo en cada recarga. */
export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'argentus_admin_sidebar_collapsed';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class Sidebar {
  @Input() appVersion = '';
  @Output() logout = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  public readonly menuItems = SIDEBAR_MENU_ITEMS;

  /** Contraído = solo íconos. Solo aplica en escritorio; en móvil el menú es un drawer. */
  public readonly isCollapsed = signal<boolean>(false);

  private readonly platformId = inject(PLATFORM_ID);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.isCollapsed.set(localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true');
    }
  }

  public toggleCollapsed(): void {
    const collapsed = !this.isCollapsed();
    this.isCollapsed.set(collapsed);

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(collapsed));
    }
  }

  public onLogout(): void {
    this.logout.emit();
  }

  public onClose(): void {
    this.close.emit();
  }
}
